import {asyncRoutes, constantRoutes, notFound,systemRoutes} from '@/router'

function copyFn(obj) {
  if (obj == null) {
    return null
  }
  var result = Array.isArray(obj) ? [] : {};
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object') {
        result[key] = copyFn(obj[key]);
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
}

export function filterAsyncRoutes(routes, roles) {

  const res = []
  routes.forEach((v, i) => {
    roles.forEach((item, index) => {
      if (item.path == v.path) {
        v.menuId = item.menuId
        v.meta.title = item.name
        v.meta.menuId = item.menuId
        if (v.children && v.children.length > 0 && item.children && item.children.length > 0) {
          v.children = filterAsyncRoutes(v.children, item.children)
        }
        res.push(v)
      }
    })
    if (v.path === '401') {
      res.push(v)
    }
  })
  // console.log(res)
  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, data) => {
      // console.log('data=66',data);
      state.addRoutes = data

    state.routes = ([].concat(constantRoutes)).concat(data)
  }
}



const actions = {
  generateRoutes({commit}, roles) {
    return new Promise(resolve => {
      let accessedRoutes = []
        let data
      let routes = copyFn(asyncRoutes)
      // 查询当前用户是否为MA系统管理员
        api.checkUserIsAdmin().then(res=>{
          if (res.data.code === 200) {
              // console.log(res.data.data,'---generateRoutes')
                accessedRoutes = filterAsyncRoutes(routes, roles)
                if(res.data.data.adminFlag===1){
                     data = accessedRoutes.concat(systemRoutes).concat(notFound)
                }else {
                     data = accessedRoutes.concat(notFound)
                }
                commit('SET_ROUTES', data)
                resolve(data)
            }
        })

        // console.log(accessedRoutes,'routes----+++++')


    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js